import A from 'utils/metrics/analytic'

// Открытие страницы прошедшего вебинара

enum originPWebinar {
  LANDING = 'lamding',
  WEBINAR_PAST_LIST = 'webinar_past_list',
  VIDEOPROJECT = 'videoproject',
  PLAYLIST = 'playlist',
  FEED = 'feed',
  LECTOR = 'lectur_personalpage',
  NOORIGIN = 'noorigin',
}

const A_wp_openWebinar = (origin: originPWebinar, id: number) => {
  if (origin === originPWebinar.NOORIGIN) {
    A.setEvent('webinar_past_open', { id: String(id) })
  } else {
    A.setEvent('webinar_past_open', { origin, id: String(id) })
  }
}

export { A_wp_openWebinar, originPWebinar }
